import { useMemo } from "react";
import * as Highcharts from "highcharts";
import { HighchartsReact } from "highcharts-react-official";
import "highcharts/modules/accessibility";

import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router";
import { AnalyzedPlan } from "@labs/shared/types/AnalyzedPlan.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";
import { generatePlanBySourceChartOptions } from "@labs/shared/util/chartOptions/generatePlanBySourceChartOptions.ts";
import { trackEvent } from "../util/analytics.ts";
import { useSharedChartStyles } from "../util/useSharedChartStyles.ts";

type PlanByEnergySourceChartProps = {
  analyzedPlan: AnalyzedPlan;
  showEditLink: boolean;
  hoveredCharts: Set<string>;
  analyticsCategory: EventCategory;
};

const PlanBySourceChart = ({
  analyzedPlan,
  showEditLink,
  hoveredCharts,
  analyticsCategory,
}: PlanByEnergySourceChartProps) => {
  const sharedChartStyles = useSharedChartStyles();
  const options: Highcharts.Options = useMemo(
    () =>
      generatePlanBySourceChartOptions(
        sharedChartStyles,
        analyzedPlan,
        false,
        hoveredCharts,
        analyticsCategory,
        trackEvent,
      ),
    [sharedChartStyles, analyzedPlan, hoveredCharts, analyticsCategory],
  );

  return (
    <Box position="relative">
      <HighchartsReact highcharts={Highcharts} options={options} />
      {showEditLink && (
        <Box position="absolute" top={8} right={8}>
          <IconButton component={Link} to="/plan" color="primary">
            <SettingsIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default PlanBySourceChart;
